import React from 'react';

export const SentryContext = React.createContext<{ captureException: (error) => void }>({ captureException: () => {} });
